import React from 'react';
import { Link } from 'react-router-dom';
import { X, Play, CreditCard, MessageSquare, BookOpen } from 'lucide-react';
import { cn } from '@/utils';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen, onClose }) => {
  // 文档链接：开发环境使用 VitePress 开发服务器，生产环境使用构建后的文档
  // 支持通过 VITE_DOCS_URL 环境变量自定义文档地址
  const docsUrl = import.meta.env.VITE_DOCS_URL ||
    (import.meta.env.DEV ? 'http://localhost:5174/docs/' : '/docs/');

  const menuItems = [
    {
      path: '/workbench',
      label: '数据工作台',
      icon: Play,
      external: false,
    },
    {
      path: '/subscribe',
      label: '订阅',
      icon: CreditCard,
      external: false,
    },
    {
      path: '/feedback',
      label: '建议反馈',
      icon: MessageSquare,
      external: false,
    },
    {
      path: docsUrl,
      label: '文档',
      icon: BookOpen,
      external: true,
    },
  ];

  return (
    <>
      {/* Overlay backdrop - only visible on mobile when open */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Drawer menu */}
      <aside
        className={cn(
          'fixed top-16 left-0 z-50 h-[calc(100vh-4rem)] w-64 bg-white border-r border-gray-200 transition-transform duration-300 lg:hidden',
          isOpen ? 'translate-x-0' : '-translate-x-full'
        )}
      >
        <div className="flex flex-col h-full">
          {/* Header with close button */}
          <div className="flex items-center justify-between p-4 border-b border-gray-200">
            <span className="font-semibold text-gray-900">菜单</span>
            <button
              onClick={onClose}
              className="p-2 rounded-lg hover:bg-warm-sand/30 transition-colors"
              aria-label="关闭菜单"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Navigation links */}
          <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
            {menuItems.map((item) => {
              const Icon = item.icon;

              if (item.external) {
                return (
                  <a
                    key={item.path}
                    href={item.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={onClose}
                    className="flex items-center gap-3 px-4 py-3 rounded-lg font-medium text-gray-700 hover:bg-warm-sand/30 transition-colors"
                  >
                    <Icon className="w-5 h-5" />
                    {item.label}
                  </a>
                );
              }

              return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={onClose}
                  className="flex items-center gap-3 px-4 py-3 rounded-lg font-medium text-gray-700 hover:bg-warm-sand/30 transition-colors"
                >
                  <Icon className="w-5 h-5" />
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </aside>
    </>
  );
};

export default MobileMenu;
